export default (text: string) => text.replace(/<\/?[^>]+(>|$)/g, '');
